export enum ContractMessages {
  activeText = "global.activeText"
}

export interface TranslationContractMessages {
  [ContractMessages.activeText]: string;
}
